import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import ToolSafetyDisclaimer from '../components/tools/ToolSafetyDisclaimer';
import CableSizeCalculator from '../components/tools/CableSizeCalculator';

const CableSizeCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="cable-size-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Cable Size Calculator"
        description="Recommend the minimum cable cross-section for a DC, single-phase, or three-phase circuit from load current, voltage drop, run length, and conductor material."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="cable-size-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <ToolSafetyDisclaimer standards="IEC 60364-5-52 and BS 7671 current-carrying-capacity tables" />
          <CableSizeCalculator />
          <ToolGuideCta guidePath="/tools/cable-size-calculator/guide" toolName="Cable Size Calculator" />
        </div>
      </section>
    </div>
  );
};

export default CableSizeCalculatorPage;
